<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>搭桥快跑</span>
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload ref="upload" class="upload-demo" :action="sys_app_logoAction" accept="xlsx" :limit="1" :on-success="importUploadSuccess" :headers="headers">
                <el-button v-permisaction="['config:runForIt:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>
            <el-col :span="1.5">
              <el-button v-permisaction="['config:runForIt:export']" type="primary" icon="el-icon-download" size="mini" @click="exportData">导出</el-button></el-col>
          </el-row>
          <div style="margin-left: 50px;margin-top: 20px;">
            <el-button v-permisaction="['config:runForIt:add']" type="primary" @click="dialogVisible = true">添加等级</el-button>
          </div>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="500px;"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="等级">
                <el-input v-model.number="levelFormData.min_level" style="width: 100px;" placeholder="最小值" />
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model.number="levelFormData.max_level" style="width: 100px;" placeholder="最大值" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="addLevel">保存</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisibleScoreEvent"
            width="500px"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="选择分组">
                <el-select v-model="scoreFormData.group" style="width: 150px" multiple placeholder="请选择">
                  <el-option
                    v-for="item in groups"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisibleScoreEvent = false">取 消</el-button>
              <el-button type="primary" @click="addGroup()">保存</el-button>
            </span>
          </el-dialog>

        </div>

        <el-tabs v-model="levelActiveName" tab-position="left" style="height: 100%;" @tab-click="handleClick">
          <el-tab-pane v-for="(tabItem,index) in tabPane" :key="index" :name="tabItem.label" :label="'Lv:'+tabItem.label">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!--------  等级配置----->
              <el-form :inline="true">
                <el-form-item label="等级">
                  <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
              </el-form>
              <!--------  等级配置----->
              <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem.label)">+分组</el-button>
              <el-form>
                <div v-if="formData.hasOwnProperty(tabItem.label)">
                  <el-row v-for="(scoreItem, scoreIndex) in formData[tabItem.label]" :key="scoreIndex">
                    <el-card class="box-card" style="margin-top: 10px">
                      <div slot="header" class="clearfix" style="height: 60px;">
                        <el-form :inline="true">
                          <el-select v-model="scoreItem.group_bak" multiple placeholder="请选择" style="width: 500px;" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name)}">
                            <el-option
                              v-for="item in groups"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            />
                          </el-select>
                        </el-form>
                      </div>
                      <el-form :inline="true">
                        <el-row v-for="(data, score_index) in scoreItem.data" :key="score_index">
                          <el-card class="box-card">
                            <div slot="header" class="clearfix">
                              <span>基础配置</span>
                            </div>
                            <el-row v-for="(item, score_index2) in data.conf" :key="score_index2">
                              <el-form-item label="层数">
                                <el-input v-model.number="item.stage" style="width: 90px;" placeholder="最大开盒数量" />
                              </el-form-item>
                              <el-form-item label="进度">
                                <el-input v-model.number="item.stepNum" style="width: 90px;" placeholder="进度" />
                              </el-form-item>
                              <el-form-item>
                                <el-button type="primary" @click="visibleArr[tabItem.label][scoreItem.group_name][score_index2].visible = true">块配置</el-button>
                                <el-drawer title="块配置" size="1400px" :visible.sync="visibleArr[tabItem.label][scoreItem.group_name][score_index2].visible">
                                  <el-form>
                                    <el-row v-for="(config, i) in item.woodConf" :key="i">
                                      <el-form-item label="块数量" style="margin-top: 10px;">
                                        <el-input v-model.number="config.woodNum" style="width: 60px;" placeholder="块数量" />
                                      </el-form-item>
                                      <el-form-item style="margin-top: 10px;" label="总块数">
                                        <el-input v-model.number="config.totalWoodPos" style="width: 80px" placeholder="权重" autocomplete="off" />
                                      </el-form-item>
                                      <el-form-item style="margin-top: 10px;" label="倍数">
                                        <el-input v-model.number="config.bet" style="width: 80px" placeholder="权重" autocomplete="off" />
                                      </el-form-item>
                                      <el-form-item style="margin-top: 10px;" label="左类型">
                                        <el-select v-model.number="config.left.optType" style="width: 70px;" placeholder="请选择">
                                          <el-option
                                            v-for="item in optTypeArr"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                          />
                                        </el-select>
                                      </el-form-item>
                                      <el-form-item style="margin-top: 10px;" label="左数量">
                                        <el-input v-model.number="config.left.num" style="width: 80px" placeholder="左数量" autocomplete="off" />
                                      </el-form-item>
                                      <el-form-item style="margin-top: 10px;" label="左权重">
                                        <el-input v-model.number="config.left.v" style="width: 80px" placeholder="左权重" autocomplete="off" />
                                      </el-form-item>
                                      <el-form-item style="margin-top: 10px;" label="右类型">
                                        <el-select v-model.number="config.right.optType" style="width: 70px;" placeholder="请选择">
                                          <el-option
                                            v-for="item in optTypeArr"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                          />
                                        </el-select>
                                      </el-form-item>
                                      <el-form-item style="margin-top: 10px;" label="右数量">
                                        <el-input v-model.number="config.right.num" style="width: 80px" placeholder="右数量" autocomplete="off" />
                                      </el-form-item>
                                      <el-form-item style="margin-top: 10px;" label="右权重">
                                        <el-input v-model.number="config.right.v" style="width: 80px" placeholder="右权重" autocomplete="off" />
                                      </el-form-item>
                                      <el-form-item style="margin-top: 10px;">
                                        <el-button v-permisaction="['config:roulette:del']" type="danger" @click="delReward(tabItem.label,scoreItem.group_name,score_index, score_index2,i)">删除</el-button>
                                      </el-form-item>
                                    </el-row>
                                  </el-form>
                                  <el-button v-permisaction="['config:roulette:add']" style="margin-top: 10px" type="primary" @click="addReward(tabItem.label,scoreItem.group_name, score_index, score_index2)">+</el-button>
                                </el-drawer>
                              </el-form-item>
                              <el-button v-permisaction="['config:runForIt:del']" type="danger" @click="delEvent(tabItem.label,scoreItem.group_name , score_index2)">删除</el-button>
                            </el-row>
                            <el-button v-permisaction="['config:runForIt:add']" type="primary" @click="addEvent(tabItem.label,scoreItem.group_name)">+</el-button>
                          </el-card>

                          <el-card class="box-card">
                            <div slot="header" class="clearfix">
                              <span>奖励配置</span>
                            </div>
                            <el-form>
                              <el-row v-for="(item, score_index2) in data.props" :key="score_index2">
                                <el-form-item label="位置" style="margin-top: 10px">
                                  <el-input v-model.number="item.position" style="width: 90px;" placeholder="位置" />
                                </el-form-item>
                                <el-form-item label="权重" style="margin-top: 10px">
                                  <el-input v-model.number="item.v" style="width: 90px;" placeholder="权重" />
                                </el-form-item>
                                <el-form-item style="margin-top: 10px">
                                  <el-button type="primary" style="margin-left: 16px;" @click="rewardvisibleArr[tabItem.label][scoreItem.group_name][score_index2].visible = true">奖励配置 </el-button>
                                  <el-drawer
                                    title="奖励配置"
                                    :visible.sync="rewardvisibleArr[tabItem.label][scoreItem.group_name][score_index2].visible"
                                    direction="rtl"
                                    :append-to-body="true"
                                    size="1000px"
                                  >
                                    <el-form :inline="true">
                                      <el-row v-for="(config, i) in item.prize" :key="i">
                                        <el-form-item label="道具" style="margin-top: 5px;">
                                          <el-select v-model.number="config.propsId" style="width: 100px;" placeholder="请选择" @change="v=>propChange(v,tabItem.label,scoreItem.group_name,score_index,score_index2, i)">
                                            <el-option
                                              v-for="(item, index) in rewardType"
                                              :key="index"
                                              :label="item.label"
                                              :value="item.value"
                                            />
                                          </el-select>
                                        </el-form-item>
                                        <el-form-item v-if="skinId.includes(config.propsId)" style="margin-top: 5px;" label="皮肤">
                                          <el-select v-if="config.propsId === 62" v-model.number="config.skin" placeholder="请选择" style="width: 120px">
                                            <el-option
                                              v-for="item in chessId"
                                              :key="item.value"
                                              :label="item.label"
                                              :value="item.value"
                                            />
                                          </el-select>

                                          <el-select v-if="config.propsId === 19" v-model="config.skin" placeholder="请选择" style="width: 120px">
                                            <el-option
                                              v-for="item in areaId"
                                              :key="item.value"
                                              :label="item.label"
                                              :value="item.value"
                                            />
                                          </el-select>
                                        </el-form-item>
                                        <el-form-item v-else label="皮肤" style="margin-top: 5px;">
                                          <el-input v-model="config.skin" style="width: 80px;" placeholder="皮肤" />
                                        </el-form-item>
                                        <el-form-item label="奖品数量" style="margin-top: 5px;">
                                          <el-input v-model.number="config.num" :readonly="skinId.includes(config.propsId)" style="width: 80px;" placeholder="奖品数量" />
                                        </el-form-item>
                                        <el-form-item style="margin-top: 5px;" label="金币取值">
                                          <el-select v-model.number="config.rtype" :disabled="config.propsId !== 14" placeholder="请选择" style="width: 120px">
                                            <el-option
                                              v-for="item in selectType"
                                              :key="item.id"
                                              :label="item.title"
                                              :value="item.id"
                                            />
                                          </el-select>
                                        </el-form-item>
                                        <el-form-item style="margin-top: 5px;">
                                          <el-button v-permisaction="['config:roulette:del']" type="danger" @click="delReward2(tabItem.label,scoreItem.group_name, score_index, score_index2, i)">删除</el-button>
                                        </el-form-item>
                                      </el-row>
                                      <el-button v-permisaction="['config:runForIt:add']" style="margin-top: 5px" type="primary" @click="addReward2(tabItem.label,scoreItem.group_name, score_index, score_index2)">+</el-button>
                                    </el-form>
                                  </el-drawer>
                                </el-form-item>
                                <el-form-item style="margin-top: 10px">
                                  <el-button v-permisaction="['config:roulette:del']" type="danger" @click="delReward(tabItem.label,scoreItem.group_name,score_index, score_index2,-1,'1')">删除</el-button>
                                </el-form-item>
                              </el-row>
                              <el-button v-permisaction="['config:runForIt:add']" style="margin-top: 5px" type="primary" @click="addEvent(tabItem.label,scoreItem.group_name, score_index, '')">+</el-button>
                            </el-form>
                          </el-card>
                          <el-button v-permisaction="['config:runForIt:add']" style="margin-top: 10px" type="primary" @click="onSubmit()">保存</el-button>
                          <el-button v-permisaction="['config:runForIt:del']" style="margin-top: 10px" type="danger" @click="delGroup(tabItem.label,scoreItem.group_name, score_index)">删除</el-button>
                        </el-row>
                      </el-form>
                    </el-card>
                  </el-row>
                </div>
              </el-form>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import { getRewardType } from '@/api/config/slot'
import { getAnimalAllList } from '@/api/config/area-cfg'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { getChestCfgAll } from '@/api/config/chest-skin-cfg'
import { exportRunForItCfg, getRunForItCfgList, importRunForItCfg, updateRunForItCfg } from '@/api/config/run-for-it-cfg'
import { getToken } from '@/utils/auth'
export default {
  name: 'RunForIt',
  data() {
    return {
      loading: false,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      tabPane: [],
      visibleArr: {},
      rewardvisibleArr: {},
      optTypeArr: [
        { label: '+', value: 1 },
        { label: '-', value: 2 },
        { label: '*', value: 3 },
        { label: '/', value: 4 }
      ],
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      rewardType: [],
      groups: [
        { label: '默认分组', value: 0 }
      ],
      dialogVisible: false,
      dialogVisibleScoreEvent: false,
      levelFormData: {
        min_level: 0,
        max_level: 0
      },
      scoreFormData: {
        group: [],
        group_name: '',
        group_bak: [],
        level_name: '',
        event_name: ''
      },
      activeName: 'first',
      levelActiveName: '',
      copyFormData: {},
      formData: {},
      skinId: [62, 19],
      chessId: [],
      areaId: []
    }
  },
  created() {
    this.getGroup()
    this.getChessId()
    this.getAreaId()
    this.getTables()
    this.getRewardTypeData()
  },
  methods: {
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importRunForItCfg({ data: response.data.path }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      exportRunForItCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    onSubmit(noTips = false) {
      // console.log('onSubmit', this.formData)
      // const data = JSON.stringify(this.formData)
      // console.log(data)
      const formData = this.formData
      let levelIndex = 0
      const postFormDataCondition = {}
      let _postData = []
      const postFormData = {}
      for (const i in formData) {
        let groupIndex = 0
        levelIndex++
        const scoreData = formData[i]
        const [minLevel, maxLevel] = i.split('-')
        for (const i2 in scoreData) {
          groupIndex++
          const scoreItem = scoreData[i2]
          const key = levelIndex + '-' + groupIndex
          if (parseInt(minLevel) > parseInt(maxLevel)) {
            this.msgError('最低等级不能大于最高等级')
            return
          }

          postFormDataCondition[key] = {
            start: parseInt(minLevel),
            end: parseInt(maxLevel),
            groups: scoreItem.group
          }

          postFormData[key] = {
            'level': minLevel + '-' + maxLevel,
            'data': scoreItem.data
          }

          const _data = scoreItem.data[0]

          if (_data.reset_min_val > _data.reset_max_val) {
            this.msgError('重置金币基础值-最小值不能大于最大值')
            return
          }

          _data.condition = key
          _postData.push(_data)
        }
      }

      console.log(_postData)
      const postCondition = JSON.stringify(postFormDataCondition)
      _postData = JSON.stringify(_postData)
      console.log(postCondition)
      console.log(_postData)
      updateRunForItCfg({ name: postCondition, data: _postData }).then(res => {
        if (res.code === 200) {
          if (!noTips) {
            this.msgSuccess(res.msg)
          }
          this.getTables(this.levelActiveName)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables(actName, onSubmit = false) {
      // this.tabPane = []
      // this.formData = []
      getRunForItCfgList().then(res => {
        if (res.code === 200) {
          const data = res.data.data
          console.log(data)
          // const tab = {}
          const cond = res.data.cond
          for (const i in cond) {
            const val = cond[i]
            const levelName = val.start + '-' + val.end
            const scoreName = val.groups.join('-')

            // 初始化弹窗
            if (!Object.prototype.hasOwnProperty.call(this.visibleArr, levelName)) {
              this.$set(this.visibleArr, levelName, {})
              this.$set(this.rewardvisibleArr, levelName, {})
            }

            // eslint-disable-next-line no-unused-vars
            if (!Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
              this.$set(this.formData, levelName, {})
            }

            if (!Object.prototype.hasOwnProperty.call(this.visibleArr[levelName], scoreName)) {
              this.$set(this.visibleArr[levelName], scoreName, [])
              this.$set(this.rewardvisibleArr[levelName], scoreName, [])
            }

            // if (!Object.prototype.hasOwnProperty.call(this.formData[levelName][scoreName], 'data')) {
            //   this.$set(this.formData[levelName][scoreName], 'data', [])
            // }

            this.$set(this.formData[levelName], scoreName, {
              'group': val.groups,
              'group_name': scoreName,
              'group_bak': val.groups,
              data: []
            })

            for (const ii in data) {
              const _event = data[ii]
              if (_event.condition === i) {
                _event.conf.forEach(() => {
                  this.visibleArr[levelName][scoreName].push({ visible: false })
                })
                _event.props.forEach(() => {
                  this.rewardvisibleArr[levelName][scoreName].push({ visible: false })
                })
                this.$set(this.formData[levelName][scoreName], 'data', [_event])
              }
            }

            // 等级
            let findIndex = -1
            this.tabPane.forEach((item, index) => {
              if (item.label === levelName) {
                findIndex = index
              }
            })

            if (findIndex === -1) {
              this.tabPane.push({
                label: levelName,
                min_level: val.start,
                max_level: val.end,
                bak_min_level: val.start,
                bak_max_level: val.end,
                add: true
              })
            }
            console.log('actName', actName)
            if (actName) {
              this.levelActiveName = actName
            } else {
              this.levelActiveName = levelName
            }
          }

          // this.onSubmit(false)
          console.log('----', this.rewardvisibleArr2)
        }
      })
    },
    handleClose(d, levelName, scoreName, index) {
      this.visibleArr[levelName][scoreName][index].visible = false
    },
    handleRewardClose(d, levelName, scoreName, index) {
      this.rewardvisibleArr[levelName][scoreName][index].visible = false
    },
    levelChange(newVal, isMin, bakMin, bakMax) {
      newVal = parseInt(newVal)
      const oldLevelName = bakMin + '-' + bakMax
      console.log('old', oldLevelName)
      let newLevelName = ''
      if (isMin) {
        newLevelName = newVal + '-' + bakMax
      } else {
        newLevelName = bakMin + '-' + newVal
      }

      if (Object.prototype.hasOwnProperty.call(this.formData, newLevelName)) {
        // if (this.formData.hasOwnPropert(newLevelName)) {
        this.msgError('修改失败')
        return
      }

      const oldData = this.formData[oldLevelName]
      Vue.delete(this.formData, oldLevelName)
      // eslint-disable-next-line no-undef
      this.$set(this.formData, newLevelName, oldData)
      // 修改弹窗
      const oldVisle = this.visibleArr[oldLevelName]
      Vue.delete(this.visibleArr, oldLevelName)
      this.$set(this.visibleArr, newLevelName, oldVisle)
      // 修改弹窗
      const oldRewardVisle = this.rewardvisibleArr[oldLevelName]
      Vue.delete(this.rewardvisibleArr, oldLevelName)
      this.$set(this.rewardvisibleArr, newLevelName, oldRewardVisle)

      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === oldLevelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })
      if (fileIndex > -1) {
        const oldTab = this.tabPane[fileIndex]
        oldTab['label'] = newLevelName
        if (isMin) {
          oldTab['bak_min_level'] = newVal
          oldTab['min_level'] = newVal
        } else {
          oldTab['bak_max_level'] = newVal
          oldTab['max_level'] = newVal
        }
        this.tabPane[fileIndex] = oldTab
      }
      this.levelActiveName = newLevelName
    },
    addEvent(levelName, scoreName, score_index = -1, key) {
      if (score_index < 0) {
        this.formData[levelName][scoreName].data[0].conf.push(
          {
            stage: 1,
            stepNum: 0,
            woodConf: []
          }
        )

        this.visibleArr[levelName][scoreName].push({ visible: false })
        this.rewardvisibleArr[levelName][scoreName].push({ visible: false })
      } else {
        this.formData[levelName][scoreName].data[score_index].props.push({ position: 1, v: 1, prize: [] })
      }
    },
    delEvent(levelName, scoreName, index) {
      this.formData[levelName][scoreName].data[0].conf = this.formData[levelName][scoreName].data[0].conf.filter((item, idx) => {
        return index !== idx
      })
    },
    addScoreEvent(levelName) {
      this.scoreFormData.max_score = 0
      this.scoreFormData.min_score = 0
      this.scoreFormData.level_name = levelName
      this.dialogVisibleScoreEvent = true
    },
    addGroup() {
      const score = this.scoreFormData
      if (score.group.length <= 0) {
        this.msgError('请选择分组')
        return
      }
      this.dialogVisibleScoreEvent = false
      const bakGroup = score.group
      const scoreTag = score.group.join('-')
      console.log(this.formData[score.level_name])
      // eslint-disable-next-line no-prototype-builtins
      if (!Object.prototype.hasOwnProperty.call(this.formData[score.level_name], scoreTag)) {
        this.$set(this.formData[score.level_name], scoreTag, {
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'data': []
        })

        this.$set(this.visibleArr[score.level_name], scoreTag, [])
        this.$set(this.rewardvisibleArr[score.level_name], scoreTag, [])
      }

      if (this.formData[score.level_name][scoreTag].data.length > 0) {
        this.msgError('当前分组元素已达上限')
        return
      }

      // 弹窗事件
      this.visibleArr[score.level_name][scoreTag].push({ visible: false })
      const len = this.visibleArr[score.level_name][scoreTag].length
      this.rewardvisibleArr[score.level_name][scoreTag].push({ visible: false })

      // 添加第一个元素
      this.formData[score.level_name][scoreTag].data.push({
        conf: [],
        props: []
      })

      this.activeName = score.level_name
      this.scoreFormData.group = []
      this.scoreFormData.group_bak = []
      this.scoreFormData.group_name = ''
      // console.log(this.formData)
    },
    addLevel() {
      console.log('添加等级')
      this.dialogVisible = false
      if (this.levelFormData.min_level > this.levelFormData.max_level) {
        this.msgError('最低等级不能大于最大等级')
        return
      }
      const levelName = this.levelFormData.min_level + '-' + this.levelFormData.max_level
      if (Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
        this.msgError('等级已经存在')
        return
      }
      this.tabPane.push({
        'label': this.levelFormData.min_level + '-' + this.levelFormData.max_level,
        'min_level': this.levelFormData.min_level,
        'max_level': this.levelFormData.max_level,
        'bak_min_level': this.levelFormData.min_level,
        'bak_max_level': this.levelFormData.max_level,
        add: true
      })
      this.levelActiveName = levelName
      // 初始化等级
      this.$set(this.formData, levelName, {})
      // 初始化弹窗
      this.$set(this.visibleArr, levelName, {})
      this.$set(this.rewardvisibleArr, levelName, {})
    },
    handleClick(tab, event) {
      console.log(tab.name)
      this.activeName = tab.name
    },
    scoreChange(newVal, isMin, levelName, minBak, maxBak) {
      console.log('scoreChange', newVal)
      const oldScoreName = minBak + '-' + maxBak
      let newScoreName = newVal + '-' + maxBak
      if (!isMin) {
        newScoreName = minBak + '-' + newVal
      }
      const oldData = this.formData[levelName][oldScoreName]

      if (isMin) {
        oldData.min_score = newVal
        oldData.min_score_bak = newVal
      } else {
        oldData.max_score = newVal
        oldData.max_score_bak = newVal
      }

      // // 删除旧积分
      Vue.delete(this.formData[levelName], oldScoreName)
      this.$set(this.formData[levelName], newScoreName, oldData)
      console.log(this.formData[levelName])
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    delReward2(levelName, groupName, index, index2, i) {
      this.formData[levelName][groupName].data[index].props[index2].prize = this.formData[levelName][groupName].data[index].props[index2].prize.filter((item, idx) => {
        return i !== idx
      })
    },
    addReward2(levelName, groupName, index, index2) {
      this.formData[levelName][groupName].data[index].props[index2].prize.push(
        { propsId: 1, num: 1, skin: 0, rtype: 1 }
      )
    },
    addReward(levelName, groupName, index, index2) {
      this.formData[levelName][groupName].data[index].conf[index2].woodConf.push(
        { woodNum: 1, totalWoodPos: 0, bet: 1, left: { optType: 1, num: 1, v: 1 }, right: { optType: 1, num: 1, v: 1 }}
      )
      this.rewardvisibleArr[levelName][groupName].push({ visible: false })
    },
    delReward(levelName, groupName, index, index2, i, key = '') {
      if (key !== '') {
        this.formData[levelName][groupName].data[index].props = this.formData[levelName][groupName].data[index].props.filter((item, key) => {
          return key !== index2
        })
      } else {
        this.formData[levelName][groupName].data[index].conf[index2].woodConf = this.formData[levelName][groupName].data[index].conf[index2].woodConf.filter((item, key) => {
          return key !== i
        })
      }
    },
    groupChange(v, levelName, oldGroupName) {
      v = v.sort()
      const newGroupName = v.join('-')
      const oldData = this.formData[levelName][oldGroupName]
      this.$delete(this.formData[levelName], oldGroupName)
      oldData.group = v
      oldData.group_bak = v
      oldData.group_name = newGroupName
      if (Object.prototype.hasOwnProperty.call(this.formData[levelName], newGroupName)) {
        this.msgError('当前分组已经存在')
        this.getTables(this.activeName)
        return
      }
      this.$set(this.formData[levelName], newGroupName, oldData)
      // 修改弹窗元素
      const oldVisible = this.visibleArr[levelName][oldGroupName]
      this.$delete(this.visibleArr[levelName], oldGroupName)
      this.$set(this.visibleArr[levelName], newGroupName, oldVisible)
      // 修改弹窗元素
      const oldRewardVisible = this.rewardvisibleArr[levelName][oldGroupName]
      this.$delete(this.rewardvisibleArr[levelName], oldGroupName)
      this.$set(this.rewardvisibleArr[levelName], newGroupName, oldRewardVisible)
    },
    getAreaId() {
      getChestCfgAll().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.areaId.push({ 'label': res.data[i].name, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    getChessId() {
      getAnimalAllList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.chessId.push({ 'label': res.data[i].lang_key, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    propChange(v, levelName, groupName, index, index2, i) {
      const record = this.formData[levelName][groupName].data[index].props[index2].prize[i]
      console.log('propChange', record)
      const typ = parseInt(v)
      record.num = 1
      switch (typ) {
        case 64:
          record.skin = this.chessId[0].value
          break

        case 19:
          record.skin = this.areaId[0].value
          break
        default:
          record.skin = 0
      }
      this.formData[levelName][groupName].data[index].props[index2].prize[i] = record
    },
    getGroup() {
      getUserTypeAllList().then(res => {
        if (res.code === 200) {
          res.data.forEach(res => {
            this.groups.push({ label: res.name, value: res.groupId })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    delGroup(levelName, groupName) {
      this.$delete(this.formData[levelName], groupName)
    }
  }
}
</script>

<style scoped>
</style>
